<template>
  <div class="tabbar">
    <van-tabbar v-model="active"
                active-color="#00C3AC">
      <van-tabbar-item icon="home"
                       to="/layout/home">首页
      </van-tabbar-item>
      <van-tabbar-item icon="wode"
                       to="/layout/my">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'tabbar',
  computed: {
    active: { get: function () { return this.$route.path === '/layout/home' ? 0 : 1 }, set: function () { } }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tabbar {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Tabbar.vue